<template>
  <div class="header">
    <b-container>
      <b-row align-v="center">
        <b-col md="6" lg="6" xl="6">
          <router-link :to="link" class="logo">
            <img src="../assets/bni-logo.png" alt="" class="logo__desktop">
            <img src="../assets/bni-logo2.png" alt="" class="logo__mobile">
          </router-link>
        </b-col>
        <b-col md="6" lg="6" xl="6">
          <b-row align-h="end" align-v="center">
            <b-col align-h="end">
              <b-row align-h="end" align-v="center" id="time">
                <span>{{ date | moment("dddd, MMMM Do YYYY") }}</span>
                &nbsp;&nbsp;&nbsp;
                <span class="time" v-text="currentTime"></span>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Header',
  data() {
    return{
        date: moment(),
        link: this.$route.params.outlet ? '/home/'+this.$route.params.outlet : '/',
        currentTime: null
    }
  },
  methods: {
    updateCurrentTime() {
      this.currentTime = moment().format('LTS');
    }
  },
  created() {
    this.currentTime = moment().format('LTS');
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  }
}
</script>